import { Box, Grid, Link, makeStyles, Typography } from '@material-ui/core';
import React, { FC, Fragment } from 'react';
import { Variant } from '@material-ui/core/styles/createTypography';
import { Promotion } from 'kiolyn-api';

interface AvailablePromotionsProps {
  promotions: Promotion[];
  onApplyCheapestPromotion?: (promotion: Promotion) => void;
  variant?: Variant;
}

const useStyles = makeStyles(() => ({
  name: {
    flexGrow: 1
  },
  applyText: {
    textDecoration: 'underline'
  }
}));

const AvailablePromotions: FC<AvailablePromotionsProps> = ({
  promotions,
  onApplyCheapestPromotion,
  variant
}: AvailablePromotionsProps) => {
  const classes = useStyles();

  const handleApplyCheapestPromotion = (promotion: Promotion) => {
    if (onApplyCheapestPromotion !== undefined) {
      onApplyCheapestPromotion(promotion);
    }
  };

  return (
    <Box>
      {promotions.map(promotion => (
        <Fragment key={promotion.id}>
          {promotion.promotion_type === 'buy_st_get_cheapest_one_free' && (
            <Grid container>
              <Box className={classes.name}>
                <Grid container direction="column">
                  <Typography variant={variant || 'h6'} color="error">
                    {promotion.name}
                  </Typography>
                  <Typography variant="body1" color="error">
                    {promotion.note}
                  </Typography>
                </Grid>
              </Box>
              <Link
                variant={variant || 'h6'}
                className={classes.applyText}
                color="error"
                component="button"
                onClick={() => handleApplyCheapestPromotion(promotion)}
              >
                APPLY PROMOTION
              </Link>
            </Grid>
          )}
          {promotion.promotion_type === 'buystgetst' && (
            <Grid container direction="column">
              <Typography variant={variant || 'h6'} color="error">
                {promotion.name}
              </Typography>
              <Typography variant="body1" color="error">
                {promotion.note}
              </Typography>
            </Grid>
          )}
        </Fragment>
      ))}
    </Box>
  );
};

export default AvailablePromotions;
